import { render, staticRenderFns } from "./modalEditarCuenta.vue?vue&type=template&id=04370170"
import script from "./modalEditarCuenta.vue?vue&type=script&lang=js"
export * from "./modalEditarCuenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports